module.exports = __webpack_public_path__ + "static/media/badge-check.f0f58d61.svg";